"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineUrl = exports.urlUpdate = exports.urlParse = exports.urlStringify = void 0;
const lodash_1 = require("lodash");
const utils_1 = require("./utils");
const urlStringify = (stringify) => (url, query) => {
    const { baseUrl } = (0, utils_1.extractQuery)(url);
    const queryString = (0, utils_1.isQueryEmpty)(query) ? undefined : stringify(query);
    return queryString ? `${baseUrl}${queryString.startsWith('?') ? queryString : `?${queryString}`}` : baseUrl;
};
exports.urlStringify = urlStringify;
const urlParse = (parse) => (url) => {
    const { baseUrl, queryString } = (0, utils_1.extractQuery)(url);
    return {
        baseUrl,
        queryParams: queryString ? parse(queryString) : {}
    };
};
exports.urlParse = urlParse;
const urlUpdate = (parse) => (url, query, { queryMerger = lodash_1.merge }) => {
    const { baseUrl, queryParams } = (0, lodash_1.isString)(url) ? (0, exports.urlParse)(parse)(url) : url;
    return {
        baseUrl: baseUrl,
        queryParams: queryMerger(queryParams, query)
    };
};
exports.urlUpdate = urlUpdate;
/**
 * Define a new instance of Url parser and query stringifier
 * @param options - query string library and base url options
 * @returns instance with parse, stringify and update methods
 */
const defineUrl = (parser, options = {}) => ({
    /**
     * Parse the Url and return the base Url and query params
     * @param url - Url string
     * @param options - query parser options
     */
    parse: (url, { parseOptions } = {}) => {
        const parseArgs = (0, lodash_1.merge)([], options.parseOptions, parseOptions);
        return (0, exports.urlParse)((param) => parser.parse(param, ...parseArgs))(url);
    },
    /**
     * Stringify the Url with the query param object
     *
     * **Note:** This method will `remove all` parameters from the Url and replace them with the query params defined in `query` argument
     *
     * @param url - Url string | UrlWithQueryParams
     * @param query - query params object
     */
    stringify: (url, query, { stringifyOptions } = {}) => {
        const stringifyArgs = (0, lodash_1.merge)([], options.stringifyOptions, stringifyOptions);
        return (0, exports.urlStringify)((param) => parser.stringify(param, ...stringifyArgs))(url, query);
    },
    /**
     * Update the query params of the Url
     * @param url - Url string | UrlWithQueryParams
     */
    update: (url, query, { parseOptions, queryMerger = lodash_1.merge } = {}) => {
        const parseArgs = (0, lodash_1.merge)([], options.parseOptions, parseOptions);
        return (0, exports.urlUpdate)((param) => parser.parse(param, ...parseArgs))(url, query, {
            queryMerger
        });
    }
});
exports.defineUrl = defineUrl;
